export const getSearchPageUrl = (searchTerm: string): string => `/search?term=${searchTerm}`;
